import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { PowerBIReport } from 'src/app/core/models/analytics/power-bi-report';
import { EmbedConfig } from 'src/app/core/models/analytics/embed-config';
import { NgxPowerBiService } from 'ngx-powerbi';
import { models } from 'powerbi-client';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-regulatory-dashboard',
  templateUrl: './regulatory-dashboard.component.html',
  styleUrls: ['./regulatory-dashboard.component.scss']
})
export class RegulatoryDashboardComponent implements OnInit {

  reportId: any;
  embedConfig!: EmbedConfig;
  isLoading = false;
  powerBIReport = new PowerBIReport();
  pbiContainerElement: any;
  joseToken:any= [];
  streamlitUrl!: string;

  options: models.ISettings = {
    filterPaneEnabled: false,
    navContentPaneEnabled: false
  };

  constructor(private analyticsService: AnalyticsService, private powerBiService: NgxPowerBiService, private userService:UserManagementService) {
    // this.embedConfig = new EmbedConfig();
    // this.reportId = 1;
    // this.getReportById();
    // this.getPowerBIReport();
    this.getDashboardReport();
  }

  ngOnInit() {
    this.powerBIReport = new PowerBIReport();
  }

  getReportById() {
    this.isLoading = true;
    this.analyticsService.getReportDetails(this.reportId)
      .subscribe((config: PowerBIReport) => {
        this.powerBIReport = config;
        this.isLoading = false;
      });
  }

  getPowerBIReport() {
    this.isLoading = true;
    this.analyticsService.getPowerBIReport(this.reportId)
      .subscribe((config: EmbedConfig) => {
        this.embedConfig = config;
        this.isLoading = false;

        const config2 = {
          type: 'report',
          accessToken: config.accessToken ? config.accessToken : config.embedToken.token,
          tokenType: 1,
          embedUrl: config.embedUrl,
          id: config.id,
          settings: {
            filterPaneEnabled: false,
            navContentPaneEnabled: false
          },
        };
        this.pbiContainerElement = <HTMLElement>(document.getElementById('pbi-container'));
        this.pbiContainerElement.style.height = window.innerHeight - 210 + 'px';
        this.powerBiService.embed(this.pbiContainerElement, config2);
      });
  }

  getDashboardReport(){
    this.userService.generateJoseJWT("changeViewer")
      .subscribe((config: string) => {
        this.joseToken = config;
        this.streamlitUrl = "https://dashboards.finreg-e.com/?key=" + this.joseToken.message;
        this.isLoading = false;
      });
  }

  onEmbedded(report: any) {
    (report.element.childNodes[0] as HTMLElement).style.height = window.innerHeight - 210 + 'px';
  }

}
